import { getSvgIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import HeadingSummaryBlock from '@stories/Components/Misc/HeadingSummaryBlock/HeadingSummaryBlock';
import * as React from 'react';
import MembershipCard from './MembershipCard/MembershipCard';
import S from './Pricing.styles';
const Pricing = (props) => {
    const tabRef = React.useRef([]);
    const [active, setActive] = React.useState(0);
    const [focusId, setFocusId] = React.useState();
    if (!props.cards) {
        return null;
    }
    return (React.createElement(S.Container, { id: props.anchorId, translations: props.translations },
        React.createElement(HeadingSummaryBlock, { ...props, layout: 'split' }),
        React.createElement(S.Tabs, null,
            React.createElement(S.TabGrid, { role: "tablist" }, props.cards.map((tab, i) => (React.createElement(S.Tab, { key: `${tab.id}-tab`, id: tab.id, ref: (el) => (tabRef.current[i] = el), role: "tab", "aria-selected": active === i, onClick: (e) => {
                    e.preventDefault();
                    if (active !== i) {
                        setActive(i);
                    }
                }, onFocus: () => setActive(i), tabIndex: active !== i ? -1 : undefined, onKeyDown: (event) => {
                    const nextIndex = i === props.cards.length - 1 ? 0 : clamp(i + 1, props.cards.length - 1);
                    const prevIndex = i === 0 ? props.cards.length - 1 : clamp(i - 1, props.cards.length - 1);
                    switch (event.key) {
                        case 'ArrowRight':
                        case 'ArrowDown':
                            event.preventDefault();
                            event.stopPropagation();
                            tabRef.current[nextIndex]?.focus();
                            break;
                        case 'ArrowLeft':
                        case 'ArrowUp':
                            event.preventDefault();
                            event.stopPropagation();
                            tabRef.current[prevIndex]?.focus();
                            break;
                        case 'Home':
                            tabRef.current[0]?.focus();
                            break;
                        case 'End':
                            tabRef.current[props.cards.length - 1]?.focus();
                            break;
                        default:
                            break;
                    }
                } },
                React.createElement(S.TabIcon, null, getSvgIcon(tab.tabIcon)),
                React.createElement(S.TabTitle, null, tab.title)))))),
        React.createElement(S.CardHolder, null, props.cards.map((card, i) => (React.createElement(S.Card, { key: card.id, "data-active": active === i, role: "tabpanel", "aria-labelledby": card.id },
            React.createElement(MembershipCard, { ...card, currentActive: active, thisId: i, setIsActive: () => setActive(i), focusId: focusId, totalLength: props.cards.length, setFocusId: (i) => setFocusId(i) })))))));
};
export default Pricing;
